import React, { useEffect, useRef } from 'react';
import '../styles/style.css';
import '../styles/mediaqueries.css';
import nggImage from '../assets/ngg.png';
import fileImage from '../assets/idayliff-mobile.webp';
import hbnbImage from '../assets/hbnb.png';

const projects = [
    {
        image: fileImage,
        alt: 'iDayliff Mobile',
        tag: 'Flutter · IoT',
        title: 'iDayliff Mobile',
        desc: 'Remote monitoring and control of Dayliff pump systems via mobile. Real-time IoT data at your fingertips.',
        links: [
            {
                label: 'Play Store ↗',
                url: 'https://play.google.com/store/apps/details?id=com.dayliff.iotclient&hl=en',
            },
        ],
        style: { transform: 'scale(0.85)' },
    },
    {
        image: nggImage,
        alt: 'TukoNewsApp',
        tag: 'Android · News',
        title: 'TukoNewsApp',
        desc: 'Kenyan news aggregator with a clean, fast interface. Fetches and organises top stories from Tuko.',
        links: [
            {
                label: 'GitHub ↗',
                url: 'https://github.com/IdrisFallout-Selfhosted/TukoNewsApp',
            },
        ],
    },
    {
        image: hbnbImage,
        alt: 'GeminiAIChatBot',
        tag: 'AI · Flutter',
        title: 'GeminiAIChatBot',
        desc: 'Conversational AI app powered by Google Gemini. Built in Flutter with a smooth, responsive chat UI.',
        links: [
            {
                label: 'GitHub ↗',
                url: 'https://github.com/IdrisFallout-Selfhosted/GeminiAIChatBot_App',
            },
        ],
    },
];

function ProjectCard({ project }) {
    const { image, alt, tag, title, desc, links, style } = project;

    return (
        <div className="details-container color-container fade-up">
            {/* Image */}
            <div className="article-container" style={{
                justifyContent: 'center',
                padding: '1rem 0',
                overflow: 'hidden',
                borderRadius: '0.75rem',
            }}>
                <img
                    src={image}
                    alt={alt}
                    className="project-img"
                    draggable={false}
                    onContextMenu={(e) => e.preventDefault()}
                    style={{...style, userSelect: 'none', pointerEvents: 'auto'}}
                />
            </div>

            {/* Meta */}
            <p className="project-tag">{tag}</p>
            <h2 className="experience-sub-title project-title">{title}</h2>
            <p style={{
                fontSize: '0.88rem',
                color: 'var(--dim)',
                marginBottom: '1.25rem',
                lineHeight: 1.6,
                textAlign: 'left',
            }}>
                {desc}
            </p>

            {/* Links */}
            <div className="btn-container" style={{ justifyContent: 'flex-start' }}>
                {links.map(({ label, url }) => (
                    <button
                        key={label}
                        className="btn btn-color-2 project-btn"
                        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                    >
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
}

function Projects() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.fade-up').forEach((el, i) => {
                            setTimeout(() => el.classList.add('visible'), i * 120);
                        });
                    }
                });
            },
            { threshold: 0.1 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="projects" ref={sectionRef}>
            <div className="scan-line" />

            <p className="section__text__p1">Browse My Recent</p>
            <h1 className="title">Projects</h1>

            <div className="experience-details-container">
                <div className="about-containers" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                    gap: '1.5rem',
                }}>
                    {projects.map(project => (
                        <ProjectCard key={project.title} project={project} />
                    ))}
                </div>
            </div>

            <div className="more_projects">
                <button
                    className="btn btn-color-2 project-btn"
                    onClick={() => window.location.href = './projects'}
                >
                    Explore More →
                </button>
            </div>
        </section>
    );
}

export default Projects;